module.exports = __webpack_public_path__ + "static/services_bar-f25fd16e9f2bc1e1440da76419686cc4.jpg";